import { Button } from "@src/components/Forms";
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = ({}) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <div className="w-full md:w-[25rem] sticky top-0 left-0 z-30">
        <div className="w-full flex items-center space-x-2 p-4 bg-white">
          <div className="flex flex-col items-center justify-center w-screen h-screen">
            <div className="text-primary text-center font-bold  text-3xl">
              404 | PAGE NOT FOUND
            </div>
            <Button
              className="max-w-max self-center mt-4"
              onClick={() => navigate("/")}
            >
              Kembali
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
